export default __webpack_public_path__ + "static/media/phone.888569ab.svg";